// Klasse "dpr-fractional" op <html> bij een gebroken pixelverhouding (bijv.
// Windows 200% × Chrome-zoom 80% = 1,6). Dan rondt Chrome randen en
// patronen ongelijk af (stippen-moiré, wegvallende
// rijlijnen). Bij 1×/2×/3× (Mac) verandert er niets. Volgt zoomen en ander scherm.
// --dot-size: stippentegel (normaal 2px) op een heel aantal schermpixels,
// zodat elke stip gelijk is: bij 1,6× of 1,8× 4 schermpixels, net als op 2×.
function update() {
  const dpr = window.devicePixelRatio || 1;
  const root = document.documentElement;
  root.classList.toggle("dpr-fractional", Math.abs(dpr - Math.round(dpr)) > 0.01);
  root.style.setProperty("--dot-size", `${(2 * Math.max(1, Math.round(dpr))) / dpr}px`);
  window.matchMedia(`(resolution: ${dpr}dppx)`).addEventListener("change", update, { once: true });
}

if (typeof window !== "undefined") update();
